import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import Loader from '../loader/loader';
import GenerateAffiliateModal from './GenrateAffilateModel.js';
import PromoCodeListingTable from './promoCodeListingTable.js';
import { adminInstance } from '../../config/axios.js';

const GenerateAffiliateLineSection = () => {
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);
  const getAdminAllPromoList = async () => {
    try {
      setLoading(true);
      const response = await adminInstance().get('api/admin/getAdminPromoList');
      console.log('Response', response);
      if (response?.data?.code === 200) {
        setData(response?.data?.data);
      }
    } catch (error) {
      setLoading(false);
      console.log('Error', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAdminAllPromoList();
  }, []);

  return (
    <>
      <Fragment>
        <Breadcrumb title='Generate Affiliate Link' parent='Team' />
        <Container fluid={true}>
          <div className='admin-card'>
            <Card>
              <CardHeader>
                <h5>All Generate Affiliate Link </h5>
              </CardHeader>
              <CardBody>
                <div className='btn-popup pull-right'>
                  <Link
                    onClick={() => setModalShow(true)}
                    className='btn btn-secondary main-btn'
                  >
                    New Generate Affiliate Link
                  </Link>
                </div>
                <div className='clearfix'></div>
                <div
                  id='batchDelete'
                  className='category-table user-list order-table coupon-list-delete'
                >
                  {!loading ? (
                    data.length > 0 && (
                      <PromoCodeListingTable
                        multiSelectOption={true}
                        myData={data}
                        pageSize={10}
                        pagination={true}
                        class='-striped -highlight'
                      />
                    )
                  ) : (
                    <Loader />
                  )}
                </div>
              </CardBody>
            </Card>
          </div>
        </Container>
        <GenerateAffiliateModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          setModalShow={setModalShow}
          getAdminAllPromoList={getAdminAllPromoList}
        />
      </Fragment>
    </>
  );
};
export default GenerateAffiliateLineSection;
